<template>
  <v-layout>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{dialogTitle}}</v-card-title>
        <v-card-text>{{dialogText}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex xs12 md6 offset-md3>
      <v-alert type="info" :value="shiftStarted">This shift was started at {{lastStart}}</v-alert>
      <div class="text-xs-center mt-5" v-if="loading">
        <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
      </div>
      <Clock-In v-if="!shiftStarted && loading === false"></Clock-In>
      <Clock-Out v-if="shiftStarted && loading === false"></Clock-Out>
    </v-flex>
  </v-layout>
</template>

<script>
import dbPromise from '../dbPromise'
import moment from 'moment'

export default {
  props: ['intent'],
  data () {
    return {
      lastStart: '',
      shiftStarted: false,
      empID: this.$store.getters.user.empID,
      company: this.$store.getters.company,
      dialogText: '',
      dialog: false,
      dialogTitle: ''
    }
  },
  computed: {
    timeSheetData () {
      return this.$store.getters.timesheet
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    timeSheetData: function (val) {
      this.isShiftStarted(this.timeSheetData)
    }
  },
  created () {
    this.isShiftStarted(this.timeSheetData)
  },
  mounted () {
    this.$store.dispatch('checkLoginTime')
  },
  methods: {
    getLocalData () {
      dbPromise().then((db) => {
        let tx = db.transaction('timesheet-archive')
        let timesheetStore = tx.objectStore('timesheet-archive')
        return (timesheetStore.get(this.empID))
      }).then((val) => {
        if (val !== undefined) {
          this.isShiftStarted(val)
        }
      })
    },
    saveDataLocal (data) {
      dbPromise().then((db) => {
        let tx = db.transaction('timesheet-archive', 'readwrite')
        let timesheetStore = tx.objectStore('timesheet-archive')
        timesheetStore.put(data, this.empID)
        return tx.complete
      }).then(() => {
        console.log('data saved locally')
      })
    },
    isShiftStarted (data) {
      for (let day in data) {
        this.shiftStarted = false
        if (typeof (data[day].end) === 'undefined') {
          this.shiftStarted = true
          this.lastStart = moment(data[day].start).format('DD/MM/YYYY HH:mm')
          break
        }
      }
      if (this.shiftStarted === true && this.intent === 'in') {
        this.dialog = true
        this.dialogText = 'You have started a shift that has not been finished, you need to Clock Out first.'
        this.dialogTitle = 'Shift already started.'
      } else if (this.shiftStarted === false && this.intent === 'out') {
        this.dialog = true
        this.dialogText = 'You haven\'t started a shift yet, you need to Clock In first.'
        this.dialogTitle = 'Shift not started.'
      } else {
        this.dialog = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TimesheetEntry.vue